import React from "react";
import { NavLink, useLocation } from "react-router-dom";
const Breadcomp = () => {
    const location = useLocation();

    const iscartpage = location.pathname === "/cart";
    const isaddresspage = location.pathname === "/deliveryaddress";
    const isPaymentPage = location.pathname === "/Payment";
    const ispaymentfail = location.pathname === "/order/payment-failure";
    return (
        <div className="d-flex  align-items-center">
            <NavLink to="/cart" className={`breadcomp-titles textdecoration-none ${iscartpage && "activebreadcomp-titles"} `}>Cart</NavLink>
            <div>/</div>
            <NavLink to="/deliveryaddress" className={`breadcomp-titles textdecoration-none ${isaddresspage && "activebreadcomp-titles"} `}>Address</NavLink>
            <div>/</div>
            {
                ispaymentfail ?
                <div  className={`breadcomp-titles textdecoration-none ${ispaymentfail && "activebreadcomp-titles"} `}>Payment</div>:
                <NavLink to="/Payment" className={`breadcomp-titles textdecoration-none ${isPaymentPage && "activebreadcomp-titles"} `}>Payment</NavLink>

            }
           



        </div>
    )
}
export default Breadcomp;